import Page from 'flarum/common/components/Page';
import IndexPage from 'flarum/forum/components/IndexPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import listItems from 'flarum/common/helpers/listItems';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
import dayjs from 'dayjs';
export default class BirthdaysPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.users = [];
    this.setResults(this.loadUsers());
  }
  view() {
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    return m("div", {
      className: "BirthdaysPage"
    }, IndexPage.prototype.hero(), m("div", {
      className: "container"
    }, m("div", {
      className: "sideNavContainer"
    }, m("nav", {
      className: "IndexPage-nav sideNav"
    }, m("ul", null, listItems(IndexPage.prototype.sidebarItems().toArray()))), m("div", {
      className: "IndexPage-results sideNavOffset"
    }, m("div", {
      className: "UserBirthdaysList"
    }, m("ul", {
      className: "UserBirthdaysList-users"
    }, this.users.map(user => m("li", null, m(Link, {
      href: app.route.user(user)
    }, m(Avatar, {
      user: user
    })), m("div", {
      className: "UserBirthdaysList-main"
    }, m(Link, {
      href: app.route.user(user)
    }, username(user)), m("ul", {
      className: "UserStats"
    }, m("li", null, app.translator.trans('datlechin-birthdays.forum.page.discussion_count', {
      count: user.discussionCount()
    })), m("li", null, app.translator.trans('datlechin-birthdays.forum.page.post_count', {
      count: user.commentCount()
    }))))))))))));
  }
  loadUsers() {
    const today = dayjs().format('YYYY-MM-DD');
    return app.store.find('users', {
      filter: {
        birthday: today
      }
    });
  }
  setResults(results) {
    results.then(users => {
      this.users = users;
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/BirthdaysPage', BirthdaysPage);